import { getObjectPropertyValue, isTheSameDay, addDays, isTheSameYear } from 'easit--utils';
import * as n from './numberWrapper';
// import { skSk } from './translationSkSk';
// import { csCz } from './translationCz';
import { ILoggingService } from 'eTip--common';
import moment from 'moment';
//require('numeral/locales/cs'); always use sk now, number formatting is as expected
require('numeral/locales/sk');
import { ITranslation, ITranslationForTipos, ITranslationForMts, ITranslationForTiposBoth } from './translationInterface';
export * from './languages';
export * from './translationInterface';

//const defaultTextLocale = 'en';

let currentLocale: string;
//let currentFormatLocale: string;
let currentTranslation: ITranslation = null; //expecting setLocale is called

let currentTranslationForTiposBoth: ITranslationForTiposBoth = null;


//let loggingService: ILoggingService;

//const translatedTextWithParamsOnlyParser = new RegExp(/^\{[^\{\}]*\}$/);

moment.locale(currentLocale); //for date
n.initialize("sk"  /* always sk as correct for numbers only */ /*currentFormatLocale*/); //see also below

export const getCurrentLocale = (): string => {
    return currentLocale;
};

export const getDefaultDateFormat = (): string => {
    return "DD.MM.YYYY";
}

export const setLocale = (locale: string) => {
    currentLocale = locale;
    currentTranslation = translations[locale];
    setTiposBothLocale(locale);
    if (!currentTranslation) {
        throw new Error("Translation for " + locale + " not registered");
    }
    moment.locale(locale);
};

export const setFormatLocale = (_formatLocale: string) => {
    /* always sk as correct for numbers only * /
    currentFormatLocale = formatLocale;
    n.initialize(formatLocale);
    */
}

const setTiposBothLocale = (locale: string) => {
    if (translationsForTiposBoth) {
        currentTranslationForTiposBoth = translationsForTiposBoth[locale];
    }
}

export enum NumberFormat { Default, Integer };
class NumberFormatter {
    public format(value: number, formatType: NumberFormat = NumberFormat.Default) {
        if (formatType == NumberFormat.Default) {
            return n.create(value).format("0,0.00");
        }
        if (formatType == NumberFormat.Integer) {
            value = Math.round(value);
            return n.create(value).format("0");
        }
        throw new Error("Unexpected format type");
    }
    public formatNoThousandSeparator(value: number, formatType: NumberFormat = NumberFormat.Default) {
        if (formatType == NumberFormat.Default) {
            return n.create(value).format("0.00");
        }
        if (formatType == NumberFormat.Integer) {
            return n.create(value).format("0");
        }
        throw new Error("Unexpected format type");
    }
}
export const numberFormatter = new NumberFormatter();

class CurrencyFormatter {
    private defaultCurrency: string;
    private formatter: NumberFormatter;
    private defaultNumberFormat: NumberFormat;
    public constructor(defaultCurrency: string, defaultNumberFormat?: NumberFormat) {
        this.defaultCurrency = defaultCurrency;
        this.defaultNumberFormat = defaultNumberFormat ? defaultNumberFormat : NumberFormat.Default;
        this.formatter = new NumberFormatter();
    }

    public format(value: number, formatType?: NumberFormat) {
        return this.formatter.format(value, formatType ? formatType : this.defaultNumberFormat) + " " + this.defaultCurrency;
    }

    public formatWithoutCurrency(value: number, formatType?: NumberFormat) {
        return this.formatter.format(value, formatType ? formatType : this.defaultNumberFormat);
    }
}
export let currencyFormatter = new CurrencyFormatter("€");
export let pointsFormatter = new CurrencyFormatter("p.", NumberFormat.Integer);

export let currency = '€';
export let pointsCurrency = "p.";

export const setCurrency = (currencyToSet: string, pointsCurrencyToSet: string) => {
    currency = currencyToSet;
    pointsCurrency = pointsCurrencyToSet;
    currencyFormatter = new CurrencyFormatter(currencyToSet);
    pointsFormatter = new CurrencyFormatter(pointsCurrency, NumberFormat.Integer);
}

export enum DateFormat { DDMMYY, DDMMYYYY, DDMM, DayName };
export enum TimeFormat { HHMM, HHMMSS };
class DateTimeFormatter {

    public formatDate(value: Date, formatType: DateFormat): string {
        if (!value) {
            return "";
        }
        return moment(value).format(this.dateFormat2Format(formatType));
    }

    public formatDateAsRelative(value: Date, formatType: DateFormat, optionalYear: boolean = false): string {
        if (!value) {
            return "";
        }
        const now = new Date();
        const t = translation();
        if (isTheSameDay(now, value)) {
            return t.today;
        }
        if (isTheSameDay(addDays(now, 1), value)) {
            return t.tomorrow;
        }
        if (isTheSameDay(addDays(now, -1), value)) {
            return t.yesterday;
        }
        if (optionalYear && isTheSameYear(now, value)) {
            formatType = DateFormat.DDMM;
        }
        return this.formatDate(value, formatType);
    }

    public formatTime(value: Date, formatType: TimeFormat): string {
        if (!value) {
            return "";
        }
        return moment(value).format(this.timeFormat2Format(formatType));
    }

    public formatDateTime(value: Date, dateFormatType: DateFormat, timeFormatType: TimeFormat, separator: string = " "): string {
        return this.formatDate(value, dateFormatType) + separator + this.formatTime(value, timeFormatType);
    }

    public formatDateTimeAsRelative(value: Date, dateFormatType: DateFormat, timeFormatType: TimeFormat, separator: string = " ") {
        return this.formatDateAsRelative(value, dateFormatType) + separator + this.formatTime(value, timeFormatType);
    }

    private dateFormat2Format(format: DateFormat): string {
        switch (format) {
            case DateFormat.DDMMYY: return "DD.MM.YY";
            case DateFormat.DDMMYYYY: return "DD.MM.YYYY";
            case DateFormat.DDMM: return "DD.MM.";
            case DateFormat.DayName: return "dddd";
        }
        return "-unknown format-";
    }

    private timeFormat2Format(format: TimeFormat) {
        switch (format) {
            case TimeFormat.HHMM: return "HH:mm";
            case TimeFormat.HHMMSS: return "HH:mm:ss";
        }
        return "-unknown format-";
    }
}

export const dateFormatter = new DateTimeFormatter()

export const setLoggingService = (_aLoggingService: ILoggingService): void => {
    //loggingService = _aLoggingService;
};

export const translation = (): ITranslation => {
    return currentTranslation;
}


export const translationForTipos = (): ITranslationForTipos => {
    //type check in registerTranslation
    return <ITranslationForTipos>currentTranslation;
}

export const translationForMts = (): ITranslationForMts => {
    //type check in registerTranslation
    return <ITranslationForMts>currentTranslation;
}

export const translationForTiposBoth = (): ITranslationForTiposBoth => {
    //type check in registerTranslation
    return currentTranslationForTiposBoth;
}

export const translateForTipos = (translationKey: string, params: Object): ITranslationForTipos => {
    return translateCommon<ITranslationForTipos>(translationKey, params);
}

export const translateForMts = (translationKey: string, params: Object): ITranslationForMts => {
    return translateCommon<ITranslationForMts>(translationKey, params);
}

export const translate = (translationKey: string, params: Object): ITranslation => {
    return translateCommon<ITranslation>(translationKey, params);
}

/**
 * Returns ITranslation object with just one filled value to add a reference for used translationKey.
 *
 */
const translateCommon = <T extends ITranslation>(translationKey: string, params: Object): T => {
    let text = currentTranslation[translationKey];
    if (text === undefined) {
        throw new Error("Unexpected key " + translationKey);
    }

    const result = {};
    result[translationKey] = replaceParams(text, params);
    return <T>result;
}

export const getNumberWrapper = () => {
    return n;
};

const replaceParams = (text: string, params: Object): string => {
    return text.replace(/{(.+?)}/g, (_token, tokenContent) => createTypedValue(params, tokenContent));
}

const createTypedValue = (params: Object, tokenContent: string): string => {
    const tokens = tokenContent.split(',').map(t => t.trim());
    if (!tokens.length) {
        throw 'Invalid tokenContent.';
    }
    return getObjectPropertyValue(params, tokens[0]);
}

export const registerTranslationForMts = (langKey: string, dictionary: ITranslationForMts) => {
    translations[langKey] = dictionary;
}

export const registerTranslationForTipos = (langKey: string, dictionary: ITranslationForTipos) => {
    translations[langKey] = dictionary;
}

export const registerTranslationForTiposBoth = (langKey: string, dictionary: ITranslationForTiposBoth) => {
    if (!translationsForTiposBoth) {
        translationsForTiposBoth = {};
    }
    translationsForTiposBoth[langKey] = dictionary;
}

export interface IWodrversion {
    zero?: string;
    one: string;
    few?: string;
    more: string;
}

export const getCorrectWordVersion = (cnt: number, versions: IWodrversion): string => {
    if (currentLocale === 'en') {
        return cnt === 1 ? versions.one : versions.more;
    }
    else {
        switch (cnt) {
            case 0: return versions.zero;
            case 1: return versions.one;
            case 2:
            case 3:
            case 4: return versions.few;
            default: return versions.more;
        }
    }
}

let translations: { [key: string]: ITranslation } = {
    // sk: () => skSk,
    // cs: () => csCz
};

let translationsForTiposBoth: { [key: string]: ITranslationForTiposBoth } = null;
